// extracted by mini-css-extract-plugin
module.exports = {"video_sec":"video_type_2-module__video_sec___xNiEN","video_sec_cover":"video_type_2-module__video_sec_cover___lhzFt","watchbutton":"video_type_2-module__watchbutton___ahEeb"};